import { render } from "./miniSpinner.vue?vue&type=template&id=2ea9d316&scoped=true&ts=true"
import script from "./miniSpinner.vue?vue&type=script&lang=ts"
export * from "./miniSpinner.vue?vue&type=script&lang=ts"

import "./miniSpinner.vue?vue&type=style&index=0&id=2ea9d316&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ea9d316"]])

export default __exports__